import React, { useState, useEffect } from "react";
import LineBox from "../../../DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import LineBtn from "../../../Button/LineBtn";
import { useApi } from "../../../../hooks/useApi";
import { toast } from "react-toastify";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../Table/Pagination";
import { TotalCount } from "../../../../pages/Users/UserInfo";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import UpdatePgModal from "./ManagePayPg/UpdatePgModal";

interface IBillOrder {
  id: number;
  servName: string;
  orderNum: number;
}

export default function ManagePayPg() {
  const tableHead = ["id", "결제 PG사", "우선 순위", "업데이트"];
  const [page, setPage] = useState(0);
  const [updateModal, setUpdateModal] = useState(false);

  const { response, error, fetchData } = useApi({
    method: "get",
    url: `version/billorder?page=${page}&size=5`,
  });

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "결제 PG사 정보를 가져오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <LineBox>
        <Table tableHeadData={tableHead}>
          {response?.data?.items?.map((d: IBillOrder) => (
            <TableBody>
              <TableBodyItem>{d?.id}</TableBodyItem>
              <TableBodyItem>{d?.servName}</TableBodyItem>
              <TableBodyItem>{d?.orderNum}</TableBodyItem>
              <TableBodyItem>
                <LineBtn
                  btnText="업데이트"
                  btnClickEvent={() => setUpdateModal(true)}
                />
              </TableBodyItem>
            </TableBody>
          ))}
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {updateModal && (
        <UpdatePgModal
          closeEvent={() => setUpdateModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url: `version/billorder?page=${page}&size=5`,
            })
          }
          data={response?.data?.items}
        />
      )}
    </>
  );
}
